import styled from 'styled-components';

import { get as getTheme } from 'Components/Base/constants';
import { Flex } from 'Components/Base';

const QuizFooterWrapper = styled(Flex)`
  position: fixed;
  bottom: 0;
  box-shadow: 0 -4px 4px rgba(0, 0, 0, 0.05);
  width: 100vw;
  padding: 16px 0px;
  justify-content: center;
  align-items: center;
  background-color: white;
  @media (max-width: ${getTheme('breakpoints.2')}) {
    padding: 10px 0px;
    padding-bottom: ${(props) =>
      props.bottomOffset > 0 ? `${props.bottomOffset + 10}px` : '10px'};
  }
`;

export default QuizFooterWrapper;
